import { render, staticRenderFns } from "./PartyEventsPage.vue?vue&type=template&id=13c2fb1c&scoped=true"
import script from "./PartyEventsPage.vue?vue&type=script&lang=js"
export * from "./PartyEventsPage.vue?vue&type=script&lang=js"
import style0 from "./PartyEventsPage.vue?vue&type=style&index=0&id=13c2fb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2fb1c",
  null
  
)

export default component.exports